import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
declare var app;


@Component({
  selector: 'app-a2-store-detail',
  templateUrl: './a2-store-detail.component.html',
  styleUrls: ['./a2-store-detail.component.scss']
})
export class A2StoreDetailComponent extends GridBaseCase implements AfterViewInit {

  dataArrayList: Array<any> = [];
  KPIArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  pageName: string = null;
  tabsIndex = 0;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal
  ) {
    super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    this.LoadKPIData();
  }
  ngAfterViewInit() {
    
  }
  tabsEvent(n){
    this.tabsIndex = n
  }
  LoadData() {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    if (id) {
      id = id.split("&")[0];
    }
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else {
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (PageName == "DailyBillInquiryDetail") {
      body.RequestBody = JSON.stringify({ "orderid": id });
    } else {
      body.RequestBody = JSON.stringify({ "a_ID": id });
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.dataArrayList = [];
      that.apiObj['status'] = data.ResponseMessage.Success;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);

        });
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }


  /**
   * 获取门店KPI数据
   */
  LoadKPIData() {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    if (id) {
      id = id.split("&")[0];
    }
    let body = {
      ConfigName:"StoreKPI",
      OpType:"QUERY",
      ConfigType:"View",
      RequestBody:{}
    };
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1; 
    body.RequestBody = JSON.stringify({ "storeId": id, "year":year, month:month});
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.apiObj['status'] = data.ResponseMessage.Success;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
      if (data.ResponseMessage.Success) {
        that.KPIArrayList = data.Status.Datas;
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

}
